<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div class="mx-2 w-full max-w-lg max-h-full bg-white shadow-lg rounded-lg p-5 overflow-auto">
        <!-- <div class="w-full text-right sticky top-0 right-0">
          <button aria-label="close" class="text-xl text-gray-500" @click.prevent="close">×</button>
        </div> -->
        <form class="w-full" id="authorityForm" @submit.prevent>
          <div class="flex flex-wrap">
            <div
              v-if="!newAuthority"
              class="w-full text-left px-3 pb-3 text-teal-700 text-2xl font-bold"
            >Actualización de monitor</div>
            <div
              v-if="newAuthority"
              class="w-full text-left px-3 pb-3 text-teal-700 text-2xl font-bold"
            >Nuevo monitor</div>

            <div class="w-4/12">
              <div class="relative w-40 h-40">
                <!-- <img src="https://i.pravatar.cc/300" class="h-30 w-30 mt-1 rounded-full border-solid border-4 border-teal-500"> -->
                <img
                  :src="authority.profile_image"
                  class="h-full w-full object-cover mt-1 rounded-full"
                  alt
                  v-bind:class="[authority.inactive ? 'border-solid border-4 border-cdmx-red' : 'border-solid border-4 border-cdmx-green']"
                />
                <div
                  class="rounded-full h-12 w-12 absolute bottom-0 right-0 items-center justify-center bg-gray-200 hover:bg-gray-400 hover:text-gray-800 cursor-pointer rounded-full border-solid border-4 border-white"
                >
                  <svg
                    class="m-2 text-gray-500"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    heigth="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M12 20h9" />
                    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
                  </svg>
                  <input
                    @change="changeImage"
                    class="cursor-pointer bottom-0 right-0 w-12 h-12 absolute block opacity-0 pin-r pin-t"
                    type="file"
                    name="profile_image"
                    accept="image/png, image/jpeg"
                  />
                </div>
              </div>
            </div>
            <div class="flex flex-col w-8/12 pl-4">
              <!-- <form class="w-full max-w-lg" id="authorityForm" @submit.prevent> -->
              <div class="w-full max-w-lg">
                <div class="flex flex-wrap -mx-3">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="name"
                    >Nombre *</label>
                    <input
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="name"
                      type="text"
                      name="name"
                      v-model="authority.name"
                    />
                    <p v-if="errors.name" class="text-red-500 text-xs italic">Ingrese su nombre.</p>
                  </div>
                </div>
                <div class="flex flex-wrap -mx-3">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="last_name"
                    >Apellido *</label>
                    <input
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="last_name"
                      type="text"
                      name="last_name"
                      v-model="authority.last_name"
                    />
                    <p v-if="errors.lastname" class="text-red-500 text-xs italic">Ingrese su apellido.</p>
                  </div>
                </div>
                <div class="flex flex-wrap -mx-3" v-if="newAuthority">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="email"
                    >Correo *</label>
                    <input
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="email"
                      type="text"
                      name="email"
                      v-model="authority.email"
                    />
                    <p
                      v-if="errors.email"
                      class="text-red-500 text-xs italic"
                    >Ingrese un correo electrónico.</p>
                    <p
                      v-if="errors.valid_email"
                      class="text-red-500 text-xs italic"
                    >Ingrese un correo electrónico válido.</p>
                  </div>
                </div>

                <div class="flex flex-wrap -mx-3 pb-3">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="project_id"
                    >Proyecto *</label>
                    <div class="relative">
                      <select
                        id="project_id"
                        v-model="authority.project_id"
                        name="project_id"
                        class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      >
                        <option
                          v-for="(option, index) in authorityTypes"
                          v-bind:value="option.id"
                          :key="index"
                        >{{ option.nombre }}</option>
                      </select>
                      <div
                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                      >
                        <svg
                          class="fill-current h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                          />
                        </svg>
                      </div>
                    </div>
                    <p
                      v-if="errors.category"
                      class="text-red-500 text-xs italic pt-3"
                    >Seleccione un proyecto.</p>
                  </div>
                </div>

                <div class="flex flex-wrap -mx-3">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="address"
                    >Dirección</label>
                    <input
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="address"
                      type="text"
                      name="address"
                      v-model="authority.address"
                    />
                    <p
                      v-if="errors.address"
                      class="text-red-500 text-xs italic"
                    >Ingrese una dirección.</p>
                  </div>
                </div>

                <div class="flex flex-wrap -mx-3">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="phone_number"
                    >Teléfono</label>
                    <input
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-1 leading-tight focus:outline-none focus:bg-white"
                      id="phone_number"
                      type="tel"
                      pattern="[0-9]{10}"
                      name="phone_number"
                      v-model="authority.phone_number"
                    />
                    <small class="mb-2 text-gray-600"><i>Teléfono a 10 dígitos</i></small>
                    <p v-if="errors.phone" class="text-red-500 text-xs italic">Ingrese un teléfono.</p>
                    <p
                      v-if="errors.valid_phone"
                      class="text-red-500 text-xs italic"
                    >Ingrese un teléfono válido de 10 dígitos.</p>
                  </div>
                </div>

                <div class="flex flex-wrap -mx-3 pb-3">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="sex"
                    >Sexo</label>
                    <div class="relative">
                      <select
                        v-model="authority.sex"
                        name="sex"
                        class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      >
                        <option
                          v-for="(option, index) in options"
                          v-bind:value="option.value"
                          :key="index"
                        >{{ option.text }}</option>
                      </select>
                      <div
                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                      >
                        <svg
                          class="fill-current h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                          />
                        </svg>
                      </div>
                    </div>
                    <p
                      v-if="errors.sex"
                      class="text-red-500 text-xs italic pt-3"
                    >Seleccione un tipo de sexo.</p>
                  </div>
                </div>

                <div class="flex flex-wrap -mx-3">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="age"
                    >Edad</label>
                    <input
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="age"
                      type="number"
                      min="0"
                      name="age"
                      v-model="authority.age"
                    />
                    <p v-if="errors.age" class="text-red-500 text-xs italic">Ingrese una edad.</p>
                  </div>
                </div>

                <div class="flex flex-wrap -mx-3">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                      for="auth_id"
                    >Id de autenticación *</label>
                    <input
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="auth_id"
                      type="text"
                      name="auth_id"
                      v-model="authority.auth_id"
                    />
                    <p
                      v-if="errors.auth_id"
                      class="text-red-500 text-xs italic"
                    >Ingrese un autenticación.</p>
					<div v-if="newAuthority" style="fontSize:10px; text-align:left;">
						- El id de autenticación servirá como primera contraseña para ingresar a la app móvil. <br>
						- El monitor debe cambiar su contraseña en la app.   <br>
						- Cambiar la contraseña no afectará a este id de autenticación.  <br>
					</div>
                  </div>
                </div>

                <div class="flex w-full justify-end mt-3">
                  <button
                    class="bg-cdmx-blue-light hover:bg-cdmx-blue-dark px-4 py-2 text-center rounded-lg text-white tracking-wide"
                    @click="saveAuthority()"
                  >Guardar</button>
                  <button
                    class="ml-2 bg-red-500 hover:bg-cdmx-red px-4 py-2 text-center rounded-lg text-white tracking-wide"
                    @click="close()"
                  >Cerrar</button>
                </div>
              <!-- </form> -->
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Monitor guardado Exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-cdmx-green"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccess = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">{{errors.codeError}}</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-cdmx-red"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
  </div>
</template>

<script>
import config from "../../vue.config.js";
import { backend_url } from "../config/url.config.ts";
import EventBus from "../event-bus";
import AlertDialog from "./AlertDialog";

export default {
  name: "authority-modal",
  data() {
    return {
      aux_authority: null,
      authority: {
        device_id: null,
        name: null,
        last_name: null,
        auth_id: null,
        address: null,
        phone_number: null,
        age: null,
        sex: null,
        id: null,
        email: null,
        project_id: null,
        profile_image:
          "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png"
      },
      options: [{ text: "Hombre", value: "H" }, { text: "Mujer", value: "M" }],
      errors: {
        email: false,
        valid_email: false,
        name: false,
        lastname: false,
        phone: false,
        age: false,
        auth_id: false,
        valid_phone: false,
        address: false,
        age: false,
        sex: false,
        category: false,
        codeError: "Ha ocurrido un error"
      },
      showingSuccess: false,
      showingError: false,
      authorityTypes: [],
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
          "Content-Type": 'multipart/form-data'
        }
      },
      configBinnacle: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        }
      }
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean
    },
    newAuthority: {
      required: true,
      type: Boolean
    }
  },
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    }
  },
  created(){
    let that = this;
/*     this.$socket.$subscribe("updateCategoryAuthorityToMonitor", () => {
      that.fetchAuthorityTypes();
    }); */
  },
  mounted() {
    EventBus.$on("editModal", this.setData);
    this.fetchAuthorityTypes();
  },
  components: {
    AlertDialog
  },
  methods: {
    reset: function() {
      this.authority = {
        name: null,
        last_name: null,
        auth_id: null,
        address: null,
        phone_number: null,
        age: null,
        sex: null,
        id: null,
        email: null,
        password: null,
        password_again: null,
        project_id: null,
        profile_image:
          "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png"
      };
      this.errors = {
        email: false,
        valid_email: false,
        name: false,
        lastname: false,
        phone: false,
        age: false,
        auth_id: false,
        valid_phone: false,
        address: false,
        age: false,
        sex: false,
        category: false,
        codeError: "Ha ocurrido un error"
      };
    },

    close() {
      this.reset();
      this.$emit("close");
    },
    changeImage: function(event) {
      const file = event.target.files[0];
      this.authority.profile_image = URL.createObjectURL(file);
    },

    setData: function(authority) {
      this.authority = Object.assign({}, authority);
      this.aux_authority = Object.assign({}, authority);
    },

    fetchAuthorityTypes() {
      this.axios
        .get(backend_url + "/api/ppd/proyectos/getProjects", this.config)
        .then(response => {
          this.authorityTypes = response.data.proyectos;
        })
        .catch(error => {
          console.error(error.response);
          if (error.response.status == 400 || error.response.status == 401) {
            if (error.response.data.name === 'TokenExpiredError' || 
                error.response.data.name === 'InvalidTokenError' || 
                error.response.data.name === 'JsonWebTokenError') {
             this.$router.push({path: '/login'}); 
            }
          }
        });
    },

    saveAuthority() {
      const telUser = document.getElementById("phone_number").value;
      const inputAuth = document.getElementById("auth_id").value.trim();
      console.log(inputAuth);
      if (telUser.length == 10) {
          if (inputAuth !== "") {
              const form = document.getElementById("authorityForm");
              const formData = new FormData(form);
              console.log(this.newAuthority)
              if (this.newAuthority) {
                const validForm = this.checkFormNewAuthority(formData);
                if (validForm) {
                  formData.append("type","authority");
                  formData.append("password",this.authority.auth_id);
                  formData.delete('profile_image');
                  //implement code for create new authority
                  this.axios
                    .post(
                      backend_url + "/users",
                      formData,
                      this.config
                    )
                    .then(response => {
                      const formImageData = new FormData(form);
                      const profile_image = formImageData.get("profile_image")
                      const mimeType      = this.checkMimeType(profile_image)
                      const newDate       = Date.now()
                      const nameFile      = "profile_image_"+response.data.user.username.replace(".","_")+"_"+response.data.user.username_id+"_"+newDate+mimeType;
                      if(profile_image && profile_image.name != ""){
                        formImageData.set('profile_image', profile_image, nameFile);
                        
                        formImageData.append('user_id', response.data.user.id);

                        return this.axios
                          .post(
                            backend_url + "/users/update_profile_image",
                            formImageData,
                            this.config
                          )
                      }else{
                        return Promise.resolve()

                      }
                    })
                    .then(response => {
                      return this.axios.post(backend_url+"/api/binnacles/monitor/save/",{
                          "module": "Monitores", 
                          "action": "Creación de un monitord", 
                          "observation": `${this.authority.name} ${this.authority.last_name}`,
                          "email": localStorage.getItem("email")
                        },
                        this.configBinnacle
                      )
                    })
                    .then(response => {
                      this.showingSuccess = true;
                      this.$emit("updateAllAuthority");
                      this.reset();
                      this.$emit("close");
                    })
                    .catch(error => {
                      if (error.response.status == 409) {
                        this.errors.codeError =
                          "Ya hay otra persona que tiene esta dirección de correo electrónico. Pruebe con otro correo";
                      }
                      if (error.response.status == 400 || error.response.status == 401) {
                        if (error.response.data.name === 'TokenExpiredError' || 
                            error.response.data.name === 'InvalidTokenError' || 
                            error.response.data.name === 'JsonWebTokenError') {
                            this.$router.push({path: '/login'}); 
                        }
                      }
                      this.showingError = true;
                    });
                }
              } else {
                const validForm = this.checkFormUpdateAuthority(formData);
                if (validForm) {
                  let newDate = Date.now()
                  const profile_image = formData.get("profile_image")
                  const mimeType      = this.checkMimeType(profile_image)

                  if(profile_image && profile_image.name != ""){
                    const nameFile = "profile_image_"+this.authority.username.replace(".","_")+"_"+this.authority.username_id+"_"+newDate+mimeType
                    formData.set('profile_image', profile_image, nameFile);
                  }

                  this.axios
                    .put(
                      backend_url + "/authorities/" + this.authority.id,
                      formData,
                      this.config
                    )
                    .then(response => {
                      let observation = ""
                      if( this.authority.name != this.aux_authority.name ||
                          this.authority.last_name != this.aux_authority.last_name){
                        observation = `${this.aux_authority.name} ${this.aux_authority.last_name} / ${this.authority.name} ${this.authority.last_name}`
                      } else {
                        observation = `${this.authority.name} ${this.authority.last_name}`
                      }

                      return this.axios.post(backend_url+"/api/binnacles/monitor/save/",{
                          "module": "Monitores", 
                          "action": "Edición de un monitor", 
                          "observation": observation,
                          "email": localStorage.getItem("email")
                        },
                        this.configBinnacle
                      )
                    })
                    .then(response => {
                      this.authority.name_category = this.authorityTypes.filter(type => {
                        if (this.authority.project_id == type.id) return type
                      })[0]["name_category"];

                      this.showingSuccess = true;
                      this.$emit("updateAuthority", this.authority);
                      this.reset();
                      this.$emit("close");
                    })
                    .catch(error => {
                      console.error(error.response);
                      if (error.response.status == 400 || error.response.status == 401) {
                        if (error.response.data.name === 'TokenExpiredError' || 
                            error.response.data.name === 'InvalidTokenError' || 
                            error.response.data.name === 'JsonWebTokenError') {
                        this.$router.push({path: '/login'}); 
                        }
                      }
                      this.showingError = true;
                    });
                }
              }
          } else {
            alert("El campo autenticación no debe estar vacío ni contener solo espacios en blanco");
          }
        } else {
          alert("El teléfono debe contener 10 dígitos");
      } 
    },

    checkFormNewAuthority: function(data) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var rePhone = /^([0-9])*$/;

      if (data.get("email") === "") {
        this.errors.email = true;
      } else {
        this.errors.email = false;
      }

      if (!re.test(data.get("email"))) {
        this.errors.valid_email = this.errors.email ? false : true;
      } else {
        this.errors.valid_email = false;
      }

      if (data.get("name") === "") {
        this.errors.name = true;
      } else {
        this.errors.name = false;
      }

      if (data.get("last_name") === "") {
        this.errors.lastname = true;
      } else {
        this.errors.lastname = false;
      }

/*       if (data.get("phone_number") === "") {
        this.errors.phone = true;
      } else {
        this.errors.phone = false;
      }

      if (!rePhone.test(data.get("phone_number"))) {
        this.errors.valid_phone = this.errors.phone ? false : true;
      } else {
        this.errors.valid_phone = false;
      }

      if (!(data.get("phone_number").length == 10)) {
        this.errors.valid_phone = this.errors.phone ? false : true;
      } else {
        this.errors.valid_phone = false;
      } */

      if (data.get("auth_id") === "") {
        this.errors.auth_id = true;
      } else {
        this.errors.auth_id = false;
      }

/*       if (data.get("address") === "") {
        this.errors.address = true;
      } else {
        this.errors.address = false;
      }

      if (data.get("age") === "") {
        this.errors.age = true;
      } else {
        this.errors.age = false;
      }

      if (data.get("sex") === null) {
        this.errors.sex = true;
      } else {
        this.errors.sex = false;
      } */

       if (data.get("project_id") === null) {
        this.errors.category = true;
      } else {
        this.errors.category = false;
      } 

      if (
        this.errors.email ||
        this.errors.valid_email ||
        this.errors.name ||
        this.errors.lastname ||
   //     this.errors.phone ||
   //     this.errors.valid_phone ||
        this.errors.auth_id ||
   //     this.errors.address ||
   //     this.errors.age ||
   //     this.errors.sex 
        this.errors.category 
      ) {
        return false;
      }

      return true;
    },

    checkFormUpdateAuthority: function(data) {
      var rePhone = /^([0-9])*$/;

      if (data.get("name") === "") {
        this.errors.name = true;
      } else {
        this.errors.name = false;
      }

      if (data.get("last_name") === "") {
        this.errors.lastname = true;
      } else {
        this.errors.lastname = false;
      }

/*       if (data.get("phone_number") === "") {
        this.errors.phone = true;
      } else {
        this.errors.phone = false;
      }

      if (!rePhone.test(data.get("phone_number"))) {
        this.errors.valid_phone = this.errors.phone ? false : true;
      } else {
        this.errors.valid_phone = false;
      }

      if (!(data.get("phone_number").length == 10)) {
        this.errors.valid_phone = this.errors.phone ? false : true;
      } else {
        this.errors.valid_phone = false;
      } */

      if (data.get("auth_id") === "") {
        this.errors.auth_id = true;
      } else {
        this.errors.auth_id = false;
      }

/*       if (data.get("address") === "") {
        this.errors.address = true;
      } else {
        this.errors.address = false;
      }

      if (data.get("age") === "") {
        this.errors.age = true;
      } else {
        this.errors.age = false;
      }

      if (data.get("sex") === null) {
        this.errors.sex = true;
      } else {
        this.errors.sex = false;
      } */

       if (data.get("project_id") === null) {
        this.errors.category = true;
      } else {
        this.errors.category = false;
      } 

      if (
        this.errors.name ||
        this.errors.lastname ||
    //    this.errors.phone ||
    //    this.errors.valid_phone ||
        this.errors.auth_id ||
    //    this.errors.address ||
    //    this.errors.age ||
    //    this.errors.sex /* ||
        this.errors.category 
      ) {
        return false;
      }

      return true;
    },
    checkMimeType(file){
      let mimeType = ""
      switch (file.type) {
        case "image/jpeg":
          mimeType = ".jpeg"
          break;
        case "image/png":
          mimeType = ".png"
          break;
        case "image/jpg":
          mimeType = ".jpg"
          break;
        default:
          mimeType = ""
          break;
      }
      return mimeType;
    }
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
.text-teal-700 {
  color: #6e5b25;
}
</style>